/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__box__block--description').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.product-single__box__block--tab accordion-group').prepend('<details><summary><p class="f-family--heading u-large u-text-transform--none u-color-text">' + tabName + '</p><summary-icon><i class="icon icon--plus-t" aria-hidden="true"></i></summary-icon></summary><details-content><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></details-content></details>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });
  // $(".js-unique-trigger").click(function() {
  //   var thisItem = $(this).attr("href");
  //   var activeClass = "js-active";
  //   //check if clicked is active
  //   if ($(thisItem).hasClass(activeClass)) {
  //     //close current item
  //     $(this).removeClass(activeClass);
  //     $(thisItem)
  //     .removeClass(activeClass)
  //     .stop()
  //     .slideUp();
  //   } else {
  //     //open and activate this item
  //     $(thisItem)
  //     .addClass(activeClass)
  //     .stop()
  //     .slideDown();
  //     $(this).addClass(activeClass);
  //   }
  //   return false;
  // });
});
